import React, { useEffect, Suspense, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import "bootstrap-icons/font/bootstrap-icons.css";
import { logout } from "./actions/auth";
import EventBus from "./utilities/EventBus";
import './assets/css/style.css'
import Routes from './components/routing/Routes';
import './config';
import Layout from './components/layout/Layout';
import AppLogout from "./utilities/AppLogout"
import 'font-awesome/css/font-awesome.min.css';

function App() {
  const { user: currentUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  var is_login = 0;
  if (globalThis.config.Settings.ApiConfiguration.Appurl != window.location.href) {
    is_login = 1;
  }
  const logOut = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);

  useEffect(() => {
    EventBus.on("logout", () => {
      logOut();
    });

    return () => {
      EventBus.remove("logout");
    };
  }, [currentUser, logOut]);


  const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');

  const completeurl = window.location.href;
  return (
    <>
      {/* <Routes /> */}
      {
         (completeurl == globalThis.config.Settings.ApiConfiguration.Appurl
          || completeurl+"/" == globalThis.config.Settings.ApiConfiguration.Appurl
          || completeurl == globalThis.config.Settings.ApiConfiguration.Appurl + "as"
          || completeurl == globalThis.config.Settings.ApiConfiguration.Appurl + "StaffDashboard"
          || completeurl == globalThis.config.Settings.ApiConfiguration.Appurl + "StaffDashboard/as"
          || completeurl == globalThis.config.Settings.ApiConfiguration.Appurl + "PublicDashboard"
          || completeurl == globalThis.config.Settings.ApiConfiguration.Appurl + "publicTOFInfo"
          || completeurl.includes(globalThis.config.Settings.ApiConfiguration.Appurl + "ResetPassword")
          || completeurl == globalThis.config.Settings.ApiConfiguration.Appurl + "PublicDashboard/as"
          || completeurl == globalThis.config.Settings.ApiConfiguration.Appurl + "NewsDetails"
          || completeurl == globalThis.config.Settings.ApiConfiguration.Appurl + "NewsDetails/as"
          || completeurl == globalThis.config.Settings.ApiConfiguration.Appurl + "DigitalDocument"
          || completeurl == globalThis.config.Settings.ApiConfiguration.Appurl + "DigitalDocument/as"
          || completeurl == globalThis.config.Settings.ApiConfiguration.Appurl + "Contact"
          || completeurl == globalThis.config.Settings.ApiConfiguration.Appurl + "Contact/as"
          || completeurl == globalThis.config.Settings.ApiConfiguration.Appurl + "SessionExpired"
          || completeurl == globalThis.config.Settings.ApiConfiguration.Appurl + "SessionExpired/as"
        )

          ? (
            <Suspense fallback={<div>Loading... </div>}>
              {
                <Routes />
              }
            </Suspense>
          )
          :
          (<Layout>
            <Suspense fallback={<div>Loading... </div>}>
              {
                <AppLogout>
                  <Routes />
                </AppLogout>
              }
            </Suspense>
          </Layout>)
      }
    </>



  )
}
export default App;


